import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ApiRequest from "../../../helper/ApiRequest";
import { ApiEndpoints } from "../../../helper/ApiEndpoints";
import DataTable from "../../../component/DataTable";
import { toast } from "react-toastify";
import AdminHeader from "../../../component/AdminHeader";

const listEndpoint = ApiEndpoints.job.list;
const deleteEndpoint = ApiEndpoints.job.delete;
const tableHeader = ["Date", "Job Title", "Department", "Location", "status"];
const tbody = ["date", "title", "department_name", "location_name", "openpost",];

export default function Job() {
  const [data, setData] = useState([]);

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", listEndpoint);
      const result = response.jobs;
      setData(result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    dataFetch();
  }, []);

  const handleDelete = async (job_id) => {
    const payload = { job_id };
    try {
      const response = await ApiRequest("POST", deleteEndpoint, payload);
      toast.success(response.message);
      dataFetch();
    } catch (error) {
      console.log(error);
    }
  };

  const pagename = {
    name: 'Career Management',
    user: 'Admin',
    innerpage: 'Career Management / Jobs'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />

      <div className="add-btn-section">
        <Link className="admin-add-btn" to={"/add-job"}> Add +</Link>
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath={"edit-job"}
          onDelete={handleDelete}
        />
      </div>
    </>
  );
}
